import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgGravityFormsRegularIcon = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 31 31",
	...props,
	children: [/* @__PURE__ */ _jsx("path", {
		fill: "#FF4F00",
		d: "M26.5 19.5a4 4 0 0 1-1.7 3L17.2 27a4 4 0 0 1-3.5 0L6 22.7a4 4 0 0 1-1.8-3v-8.8a4 4 0 0 1 1.7-3.1l7.6-4.4a4 4 0 0 1 3.5 0l7.6 4.3a4 4 0 0 1 1.8 3z"
	}), /* @__PURE__ */ _jsx("path", {
		fill: "#fff",
		d: "M13.2 13.1h10v-2.8h-10q-2.1 0-3.5 1.5C7.5 14 7.5 20 7.5 20h15.7v-5.3h-2.9V17h-9.8a6 6 0 0 1 1.3-3.4q.5-.6 1.4-.6"
	})]
});
export default SvgGravityFormsRegularIcon;
